import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    errorBlankTitle: String,
    errorBlankContent: String,
    errorTooLongContent: String,
  };

  connect() {
    this.errorPlaceholder = this.element.querySelector(".js-error-placeholder");
    this.errorContainer = this.element.querySelector(".new-hot-news__errors");
  }

  validate(event) {
    const errors = this.collectErrors();

    if (errors.length > 0) {
      event.preventDefault();
      event.stopPropagation();
      this.displayErrors(errors);
      return false;
    }

    this.clearErrors();
    return true;
  }

  collectErrors() {
    const errors = [];

    // Validate title field
    const titleField = this.element.querySelector('input[name*="[title]"]');
    if (!titleField || !titleField.value.trim()) {
      errors.push(this.errorBlankTitleValue);
    }

    // Validate content field - get from rhino-editor
    const editor = this.element.querySelector("rhino-editor");
    const contentField = this.element.querySelector('input[name*="[content]"]');

    if (editor && contentField) {
      const content = contentField.value || "";
      const plainText = this.stripHtmlTags(content).trim();

      if (plainText.length === 0) {
        errors.push(this.errorBlankContentValue);
      } else if (plainText.length > 3000) {
        errors.push(this.errorTooLongContentValue);
      }
    } else if (!contentField || !contentField.value.trim()) {
      errors.push(this.errorBlankContentValue);
    }

    return errors;
  }

  displayErrors(errors) {
    if (!this.errorContainer) {
      this.errorContainer = this.createErrorContainer();
    }

    this.errorContainer.innerHTML = `
      <ul>
        ${errors.map((error) => `<li class="body--medium">${error}</li>`).join("")}
      </ul>
    `;

    this.errorContainer.style.display = "block";

    // Scroll to errors
    this.errorContainer.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  clearErrors() {
    if (this.errorContainer) {
      this.errorContainer.innerHTML = "";
      this.errorContainer.style.display = "none";
    }
  }

  createErrorContainer() {
    const container = document.createElement("div");
    container.className = "new-hot-news__errors";
    container.style.display = "none";

    // Insert into the error placeholder
    if (this.errorPlaceholder) {
      this.errorPlaceholder.appendChild(container);
    } else {
      // Fallback: insert at the beginning of the form
      this.element.insertBefore(container, this.element.firstChild);
    }

    return container;
  }

  stripHtmlTags(html) {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }
}
